import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useStore } from "@/lib/store";
import ProductCard from "@/components/ProductCard";

export default function FavoritesPage() {
  const { favorites, favoritesCount, t } = useStore();

  return (
    <div className="animate-fade-in" data-testid="favorites-page">
      {/* Header */}
      <div className="px-4 py-6 border-b border-zinc-800">
        <h1 className="font-display text-2xl md:text-3xl font-bold tracking-tight flex items-center gap-3">
          <Heart className="w-6 h-6" /> {t("favorites")}
        </h1>
        <p className="text-xs font-mono text-zinc-500 mt-1">{favoritesCount} {t("items")}</p>
      </div>

      {favorites.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-24 text-zinc-500 gap-4">
          <Heart className="w-20 h-20 text-zinc-700" strokeWidth={1} />
          <p className="text-sm">{t("favoritesEmpty")}</p>
          <Link to="/catalog"
            className="px-8 py-3 bg-white text-black text-xs font-display font-bold uppercase tracking-wider hover:bg-zinc-200 transition-colors">
            {t("viewCatalog")}
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 border-t border-zinc-800">
          {favorites.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      )}
    </div>
  );
}
